export default class BaseTabButtons {

    /**
     * @var {boolean}
     */
    activeTab = '';

    /**
     * @var {array}
     */
    tabButtons = [];

    init() {
        const tabButtons = this.$el.querySelectorAll('.TabButtons__button');

        tabButtons.forEach((tabButton) => {
            // if span.textContent is not in the tabButtons array, push it
            if (!this.tabButtons.includes(tabButton.getAttribute('name')) && tabButton.getAttribute('name') !== null) {
                this.tabButtons.push(tabButton.getAttribute('name'));
            }
        
        });
    }

    /**
     * initTabButtons
     * initializes the first tab button to be active
     * @param {string} firstTargetID
     * @return void
     */
    initTabButtons(firstTargetID) {

        let selectedTab = this.getSelectedTab(firstTargetID);

        console.log(selectedTab);

        this.$nextTick(() => {
            this.activeTab = selectedTab;
            this.$dispatch('pegasus-tab-item-selected', { targetID: selectedTab, tabGroup: JSON.stringify(this.tabButtons) });
        });
    }

    /**
     * getSelectedTab
     */
    getSelectedTab(target) {
        const url = new URL(window.location.href);
        const selectedTab = url.searchParams.get('selected-tab');

        if (selectedTab) {
            return selectedTab;
        }

        return target;

    }

    /**
     * showTab
     * dispatches pegasus-tab-item-selected event to be catch by TabItem to trigger their open state
     * @param {string} target 
     * @return void
     */
    showTab(targetID) {
        console.log('showTab', targetID);
        this.activeTab = targetID;
        this.$dispatch('pegasus-tab-item-selected', { targetID: targetID, tabGroup: JSON.stringify(this.tabButtons)  });
    }

}

document.addEventListener('alpine:init', () => {
    Alpine.data('tabButtons', () => new BaseTabButtons());
});